const Archive_Filter = class {

	DOMContentLoaded() {
		// this.WP_REST_URL = document.querySelector("link[rel='https://api.w.org/']").getAttribute('href') + 'wp/v2/';
		this.active_params = {};
		this.custom_events = {};
		// url stuff
		this.current_url = window.location.href;
		this.base_url = this.current_url.split('?')[0];
		// remove pager
		if ( this.base_url.indexOf('/page/') > -1 ) {
			this.base_url = this.base_url.split('page/')[0];
		}

		this.filter_anchor_elems = document.querySelectorAll('[data-filter_link="true"]');
		this.filter_body = document.querySelector('div[data-filter-body="true"]');
		this.filter_pagination = document.querySelector('div[data-filter-pagination="true"]');

		this.abortController = new AbortController();
		this.fetchRunning = false;

		this.register_custom_events();
		this.register_filters();

	}

	register_custom_events() {
		/**
		 * trigger custom events when the filter updates
		 * @type {Event}
		 */
		const update_link_event = new Event('Archive_Filter_Link_Update');
		update_link_event.filter = this;
		this.custom_events.Archive_Filter_Link_Update = update_link_event;

		/**
		 * Allow overriding of loading HTML icon
		 * @type {Event}
		 */
		const loading_event = new Event('Archive_Filter_Loading');
		loading_event.filter = this;
		// this event exists to overload this html
		// animation created on: https://loading.io/
		loading_event.loading_html = '<div style="width:100%;text-align:center;padding-top:100px;"><svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-double-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0 0;"><circle cx="50" cy="50" ng-attr-r="{{config.radius}}" ng-attr-stroke-width="{{config.width}}" ng-attr-stroke="{{config.c1}}" ng-attr-stroke-dasharray="{{config.dasharray}}" fill="none" stroke-linecap="round" r="40" stroke-width="10" stroke="#5d5d5d" stroke-dasharray="62.83185307179586 62.83185307179586"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="2s" begin="0s" repeatCount="indefinite"></animateTransform></circle><circle cx="50" cy="50" ng-attr-r="{{config.radius2}}" ng-attr-stroke-width="{{config.width}}" ng-attr-stroke="{{config.c2}}" ng-attr-stroke-dasharray="{{config.dasharray2}}" ng-attr-stroke-dashoffset="{{config.dashoffset2}}" fill="none" stroke-linecap="round" r="29" stroke-width="10" stroke="#a6a6a6" stroke-dasharray="45.553093477052 45.553093477052" stroke-dashoffset="45.553093477052"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;-360 50 50" keyTimes="0;1" dur="2s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg></div>';
		this.custom_events.Archive_Filter_Loading = loading_event;

		/**
		 * trigger custom events after filter updates are done
		 * @type {Event}
		 */
		const update_after_event = new Event('Archive_Filter_After');
		update_after_event.filter = this;
		this.custom_events.Archive_Filter_After = update_after_event;
	}

	/**
	 * Register all click <a> elements.
	 * Build the currently active elements object
	 */
	register_filters() {
		if (0 === this.filter_anchor_elems.length) {
			return; // no filter on this page
		}

		this.filter_anchor_elems.forEach((anchor_elem) => {
			const term_id = anchor_elem.dataset.term_id;
			const taxonomy = anchor_elem.dataset.taxonomy;

			// always add an empty taxonomy to the parameters
			if (!this.active_params.hasOwnProperty(taxonomy)) {
				this.active_params[taxonomy] = [];
			}

			// is current element active, if so add to active params
			if (anchor_elem.classList.contains('active')) {
				this.active_params[taxonomy].push(term_id);
			}

			// register click of the element
			anchor_elem.onclick = (event) => {
				this.filter_link_click(event)
			};
		});
	}

	/**
	 * @param {Event} event
	 */
	filter_link_click(event) {
		event.preventDefault();

		this.update_filter_by_element(event.target);
	}

	/**
	 * @param {Element|EventTarget} elem
	 */
	update_filter_by_element(elem) {
		const term_id = elem.dataset.term_id;
		const taxonomy = elem.dataset.taxonomy;
		if (typeof Filter.active_params[taxonomy] === 'undefined') {
			this.active_params[taxonomy] = [];
		}
		const index = this.active_params[taxonomy].indexOf(term_id);

		// add or remove term from the active params
		if (-1 === index) {
			elem.classList.add('active');
		} else {
			elem.classList.remove('active');
		}

		// fire update
		this.update_filter(taxonomy, term_id);

		// custom followup event
		elem.dispatchEvent(this.custom_events.Archive_Filter_Link_Update);
	}

	reset_filter() {
		const active_params = this.active_params;
		Object.keys(active_params).forEach( (key) =>  {
			active_params[key] = [];
		});
		this.update_filter();
	}

	update_filter(key, value) {
		// is a key given to update
		if (typeof key !== 'undefined') {
			// preemptively define the key
			if (typeof Filter.active_params[key] === 'undefined') {
				this.active_params[key] = [];
			}

			const index = this.active_params[key].indexOf(value);

			// add or remove term from the active params
			if (null === value) {
				this.active_params[key] = [];
			} else if (-1 === index) {
				this.active_params[key].push(value);
			} else {
				this.active_params[key].splice(index, 1);
			}
		}

		// update browser url
		this.update_browser_url();

		// update filter html links
		this.filter_anchor_elems.forEach((anchor_elem) => {
			this.update_filter_anchor(anchor_elem);
		});

		// set loading state
		this.update_loading();

		// do api call
		this.call_archive_page();
	}

	update_loading() {
		document.dispatchEvent(this.custom_events.Archive_Filter_Loading);

		if ( false !== this.custom_events.Archive_Filter_Loading.loading_html ) {
			this.filter_body.innerHTML = this.custom_events.Archive_Filter_Loading.loading_html;
		}
	};

	update_browser_url() {
		this.current_url = this.build_filter_url(this.active_params);

		history.pushState(null, null, this.current_url);
	}

	/**
	 * Update the link of the given anchor element
	 *
	 * @param {Element} elem
	 */
	update_filter_anchor(elem) {
		// deep clone, apparently the best way
		let link_params = JSON.parse(JSON.stringify(this.active_params));
		const term_id = elem.dataset.term_id;
		const taxonomy = elem.dataset.taxonomy;
		const index = link_params[taxonomy].indexOf(term_id);

		// is this now the active state?
		if (-1 === index) {
			link_params[taxonomy].push(term_id);
		} else {
			link_params[taxonomy].splice(index, 1);
		}

		// new url
		const new_url = this.build_filter_url(link_params);
		elem.setAttribute('href', new_url);
	}

	build_filter_url(params) {
		let query_params = '?';
		Object.keys(params).forEach( (filter) => {
			const key = filter;
			const values = params[filter];
			// don't include empty filters
			if (0 === values.length) {
				return;
			}
			query_params += key + '=' + values.join(',') + '&';
		});
		// strip final '&'
		query_params = query_params.replace(/&$/g, '');

		// empty filters?
		if ('?' === query_params) {
			query_params = '';
		}

		return this.base_url + query_params;
	}

	call_archive_page() {

		if (this.fetchRunning) {
			this.abortController.abort();
			this.abortController = new AbortController();

		} else {
			this.fetchRunning = true;
		}

		fetch(this.current_url, {signal: this.abortController.signal})
			.then(res => res.text())
			.then(response => {

				let result_html = new DOMParser().parseFromString(response, 'text/html');
				// update body
				let new_filter_body = result_html.querySelector('div[data-filter-body="true"]');

				if (null !== new_filter_body) {
					this.filter_body.replaceWith(new_filter_body);
					this.filter_body = new_filter_body;
				} else {
					// create a decent no `have_posts` on the page with the `data-filter-body="true"` attribute
					this.filter_body.innerHTML = '-';
				}

				// update pagination
				let new_filter_pagination = result_html.querySelector('div[data-filter-pagination="true"]');
				if (null !== new_filter_pagination) {
					this.filter_pagination.replaceWith(new_filter_pagination);
					this.filter_pagination = new_filter_pagination;
				}

				// Done updating, custom event
				document.dispatchEvent(this.custom_events.Archive_Filter_After);

			})
			.catch(err => {
				if (20 !== err.code) { // code 20 is an abbort, which is no problem
					console.log(err);
				}
			})
			.finally(() => {
				this.fetchRunning = false
			});
	}
};

const Filter = new Archive_Filter();

/******************************
 * Custom events documentation
 */

// // Custom loader HTML
// document.addEventListener('Archive_Filter_Loading', (event) => {
// 	// simply set HTML in body when loading
// 	event.loading_html = '<div>custom loader</div>';
//
// 	// empty the body when loading
// 	event.loading_html = '';
//
// 	// don't change the body when loading
// 	event.loading_html = false;
// 	// call own JS loading function
// 	console.log( 'call own function' );
// });

// // Action after an update is done
// document.addEventListener('Archive_Filter_After', (event) => {
// 	console.log('all loading/replacing done');
// });

// // Action on the clicked element (only supports the buildin click elements
// document.querySelectorAll('a[data-filter_link="true"]').forEach((input) => {
// 	input.addEventListener('Archive_Filter_Link_Update', () => {
// 		console.log(this); // the <a> element that is updated
// 	});
// });

/*****************************************
 * Implementation documentation
 * @todo
 */

export { Filter }
// window.onload = () => { Filter.DOMContentLoaded(); };
